import styled from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 6rem);
  margin-left: 6rem;
  height: calc(100vh - 7rem);
  display: block;

  @media (max-width: 600px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  padding: 2rem 5rem;
  gap: 3rem;

  @media (max-width: 1366px) {
    padding: 2rem 2rem;
    gap: 1rem;
  }
  @media (max-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
    padding: 2rem 5rem;
    gap: 2rem;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    padding: 2rem 6rem;
    gap: 2rem;
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(4, 1fr);
    padding: 2rem 2rem;
    gap: 1rem;
  }
  @media (max-width: 414px) {
    grid-template-columns: repeat(3, 1fr);
    padding: 2rem 2rem;
    gap: 1rem;
  }
`;
